import React, { useContext, useEffect, useState } from "react";
import TitlePage from "../../../../components/TitlePage";
import { Row, Col, Button, Form, InputGroup} from "react-bootstrap";
import ConsultaCentroCusto from '../../../../../lib/json/consultas/CentroCustoSelect.json'
import ResponsiveDataTable from "../../../../components/DataTable";
import LoadingSpinner from "../../../../components/LoadinSpinner";
import { ConsultaTotvsEmpresa, ConsultaTotvsEmpresaIndividual } from "../../../../../backend/ConsultaTotvsEmpresa";
import { useNavigate } from "react-router-dom";
import { usePopUp } from "../../../../components/BootBox";

function ListaCentroCusto(){
    const navigate = useNavigate();
    const { DisparaBootBox, FechaBootBox  } = usePopUp();
    const columns = [
        {
            Header: 'Filial',
            accessor: 'CTT_FILIAL',
        },
        {
            Header: 'Custo',
            accessor: 'CTT_CUSTO',
        },
        {
            Header: 'Descrição',
            accessor: 'CTT_DESC01',
        },
        {
            Header: 'Comprador',
            accessor: 'CTT_XCOMDF',
        },
        {
            Header: 'Nome Comprador',
            accessor: 'Y1_NOME',
        }
    ];
    
    var [carregar, setCarregar] = useState(false);
    var [data, setData] = useState([]);
    var consultaDefault = ConsultaCentroCusto.consulta + " WHERE CTT.D_E_L_E_T_ <> '*' AND CTT_FILIAL = FILIAL(CTT) AND CTT_CLASSE = '2' AND CTT_BLOQ = '2' ";
    consultaDefault += "GROUP BY CTT_FILIAL, CTT_CUSTO, CTT_DESC01, CTT_ENDER, CTT_BAIRRO, CTT_CEP, CTT_ESTADO, CTT_MUNIC, CTT_XTIPO, CTT_XCOMDF, Y1_NOME, Y1_USER "

    useEffect(() => {
        loadCentroCusto();
    }, []);

    // Processa consulta do grid
    const loadCentroCusto = async () => {
        setCarregar(true);
        var retConsulta = await ConsultaTotvsEmpresaIndividual( consultaDefault, ConsultaCentroCusto.tabelas );

        setData(retConsulta.data);
        setCarregar(false);
    }

    const handleAlterar = (row) =>{
        navigate(`./Alterar/${row.values.CTT_CUSTO.trim()}/${row.original.EMPRESA}${row.original.CTT_FILIAL.trim()}01`)
    }

    return (
        <>
        <Row>
            <LoadingSpinner isLoading={carregar}/>
            <Col md="12" xs="12">
                <TitlePage 
                    text="Centro de Custo"
                    exibirIncluir={false}
                />
            </Col>
            <Col md="3" xs="12">
                <Form.Group as={Col} className="md-2" controlId="formGridBuscar">
                    <InputGroup size="md" className="mb-3">
                        <Button variant="outline-primary" type="submit" onClick={loadCentroCusto}>
                            Buscar
                        </Button>
                    </InputGroup>
                </Form.Group>
            </Col>
        </Row>
        
        <Row>
            { data.length > 0 &&
                <Col md="12" xs="12">
                    <ResponsiveDataTable 
                        columns={columns} 
                        data={data} 
                        buttons= {[
                            {isAlterar: true, action: handleAlterar, label: "Alterar", icone: "MdOutlineEditNote"}
                        ]}
                    />
                </Col>
            }
        </Row>
        </>
    );
}

export default ListaCentroCusto;